/**
 * Created by yinxiaohan.
 */
const getters = {
  // user相关的state
  sourcechannel: state => state.global.sourcechannel,
  deviceModel: state => state.global.deviceModel,
  deviceId: state => state.global.deviceId
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js